//
//
//
//
//
//
//
//

import InputFrame from '@/components/universal/input/InputFrame.vue'

export default {
  name: 'CodeInput',
  components: {
    InputFrame,
  },
  props: {
    value: String,
    error: Boolean,
    disabled: Boolean,
    charCount: {
      type: Number,
      default: 6,
    },
    valueFilterFunction: Function,
    numeric: Boolean, // overrides valueFilterFunction
    obscureValues: Boolean,
    useGenericBackdropGradient: Boolean,
  },
  computed: {
    valueArray() {
      const { processedValueFilterFunction, value, charCount } = this
      const filteredValue = processedValueFilterFunction(value)
      return [...Array(charCount)]
        .map((_, i) => i >= filteredValue.length ? '' : filteredValue[i])
    },
    processedValueFilterFunction() {
      if (this.numeric) return value => value.replace(/\D/g, '')
      return this.valueFilterFunction || (value => value)
    },
  },
  methods: {
    newInput(index, element) {
      const newValue = element.value

      const newValueArray = this.processedValueFilterFunction(newValue).split('')
      const newElementValue = newValueArray.length ? newValueArray[0] : ''
      if (newElementValue !== newValue) element.value = newElementValue

      const newArray = this.valueArray.map((c, i) => {
        if (i >= index && i < (index + newValueArray.length)) {
          return newValueArray[i - index]
        } else if (i === index) { // empty value
          return ' '
        }
        return c || ' '
      })

      this.$emit('input', newArray.join('').trimEnd())
      if (newValue) this.$nextTick(this.adjustFocusIfNecessary)
    },
    deletePressed(index, currentValue) {
      const { value } = this
      const { length } = value

      const shouldDeletePreviousValue = !currentValue && index > 0 && index <= length

      if (shouldDeletePreviousValue) {
        if (index === length) this.$emit('input', value.substring(0, index - 1).trimEnd())
        else this.$emit('input', `${value.substring(0, index - 1)} ${value.substring(index)}`.trimEnd())
      }
      if (shouldDeletePreviousValue || index > length) {
        this.$nextTick(this.adjustFocusIfNecessary)
      }
    },
    leftPressed(index, element) {
      if (index > 0 && element.selectionStart === 0) {
        const newElement = this.$refs.inputs[index - 1]
        newElement.focus()
        setTimeout(() => {
          newElement.setSelectionRange(1, 1)
        })
      }
    },
    rightPressed(index, element) {
      if (index < this.charCount - 1 && element.selectionStart === element.value.length) {
        const newElement = this.$refs.inputs[index + 1]
        newElement.focus()
        setTimeout(() => {
          newElement.setSelectionRange(0, 0)
        })
      }
    },
    adjustFocusIfNecessary() {
      const { inputs } = this.$refs
      const { activeElement } = document
      const currentlyFocusedIndex = inputs.findIndex(input => input === activeElement)

      if (currentlyFocusedIndex < 0) return

      const { value, charCount } = this
      const { length } = value

      const canMoveRight = (currentlyFocusedIndex + 1) < charCount
      const canMoveLeft = currentlyFocusedIndex > 0

      const isWithinValueLength = currentlyFocusedIndex < length
      const previousInputIsWithinValueLength = (currentlyFocusedIndex - 1) < length

      const currentValueIsEmpty = !isWithinValueLength || value[currentlyFocusedIndex] === ' '
      const previousValueIsEmpty = !previousInputIsWithinValueLength || (currentlyFocusedIndex > 0 && value[currentlyFocusedIndex - 1] === ' ')

      if (canMoveRight && isWithinValueLength && !currentValueIsEmpty) { //
        inputs[currentlyFocusedIndex + 1].focus() // move cursor right
      } else if (canMoveLeft && currentValueIsEmpty && previousValueIsEmpty) {
        inputs[currentlyFocusedIndex - 1].focus() // move cursor left
      }
    },
  },
}
